import dayjs from "dayjs";
import React, { useState } from "react";
import ReactGA from "react-ga4";
import "./styles.scss";
import { useTranslation } from "react-i18next";

import { SchedulePostData } from "../../../models/SchedulePostData";
import DataSvc from "../../../services/dataSvc";
import { OptionalRender } from "../../Common/OptionalRender";
import { RecentMediaListContext } from "../../DashboardComponents/RecentPostsList";
import ModalUpdateGbpLocalPost from "../../FacilityDetailsComponents/ModalUpdateGbpLocalPost";
import ModalConfirm from "../../ModalConfirm";

export interface ISchedulePostItemProps {
  schedulePostItem: SchedulePostData;
  isShowLocationName?: boolean;
  context: RecentMediaListContext;
  canModify?: boolean;
  showEditButton?: boolean;
  showCancelButton?: boolean;
  refreshCallback?: () => void;
  onEdit?: (schedulePost: SchedulePostData) => void;
}

export const SchedulePostItem: React.FunctionComponent<
  ISchedulePostItemProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`localpostsPage.schedulePostItem.${key}`);

  const {
    schedulePostItem,
    isShowLocationName = true,
    context,
    canModify = false,
    refreshCallback,
    showEditButton = false,
    showCancelButton = false,
    onEdit,
  } = props;

  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const mediaUrl = schedulePostItem.signed_url
    ? schedulePostItem.signed_url
    : "";

  const handleEdit = () => {
    // setShowUpdateModal(true);
    // ReactGA.event({
    //   category: "schedule-post",
    //   action: "Edit Schedule Post",
    // });
  };

  const handleUpdateSuccess = () => {
    // setShowUpdateModal(false);
    // refreshData(RefreshType.SCHEDULE_POSTS);
    // refreshCallback?.();
  };

  const handleConfirmCancel = () => {
    setShowCancelModal(true);
  };

  const handleCloseConfirmCancel = () => {
    setShowCancelModal(false);
  };

  const handleCancel = async () => {
    try {
      await DataSvc.cancelSchedulePost(
        schedulePostItem.location_id.toString(),
        schedulePostItem.id.toString()
      );
      setShowCancelModal(false);
      refreshCallback?.();
    } catch {
      // axios handles errors
    }
  };

  return (
    <>
      <div className="schedule-post-item">
        <div
          className="schedule-post-top-info"
          onClick={() =>
            ReactGA.event({
              category: "dashboard",
              action: "Open Schedule Post",
              label: context,
            })
          }
        >
          <div className="left-title">
            {isShowLocationName ? schedulePostItem.location_name : ""}
          </div>
          <div className="right-title">
            {dayjs(schedulePostItem.scheduled_at).format("YYYY-MM-DD HH:mm")}
          </div>
        </div>

        <div className="schedule-post-bottom-container">
          <div className="schedule-post-img-container">
            {mediaUrl ? (
              <img
                className="schedule-post-img"
                alt="schedule-post"
                src={mediaUrl}
                referrerPolicy="no-referrer"
              />
            ) : (
              <div className="no-image">
                <div>{t("no_picture")}</div>
              </div>
            )}
          </div>
          {schedulePostItem.summary ? (
            <div className="summary">{schedulePostItem.summary}</div>
          ) : (
            <div className="no-summary">{t("no_comment")}</div>
          )}
        </div>

        <div className="schedule-post-item-controls-container">
          <div className="left-controls">
            <OptionalRender mustBeImpersonating>
              {canModify && showEditButton && (
                <button
                  className="btn btn-border"
                  onClick={onEdit ? () => onEdit(schedulePostItem) : handleEdit}
                  type="button"
                >
                  {t("edit")}
                </button>
              )}
            </OptionalRender>
          </div>

          {canModify && showCancelButton && (
            <button
              className="btn btn-red"
              onClick={handleConfirmCancel}
              type="button"
            >
              {t("cancel")}
            </button>
          )}
        </div>
      </div>

      {showUpdateModal && (
        <ModalUpdateGbpLocalPost
          onClose={() => setShowUpdateModal(false)}
          localPost={schedulePostItem as any}
          onSuccess={handleUpdateSuccess}
        />
      )}

      {showCancelModal && (
        <ModalConfirm
          title={t("cancelModal.title")}
          cancelLabel={t("cancelModal.cancel")}
          confirmLabel={t("cancelModal.confirm")}
          onClose={handleCloseConfirmCancel}
          onConfirm={handleCancel}
          translate={false}
          color="red"
        >
          <div className="cancel-modal-schedule-post-preview-container">
            <SchedulePostItem
              key={schedulePostItem.id}
              schedulePostItem={schedulePostItem}
              isShowLocationName={true}
              context={RecentMediaListContext.OWN_LOCATION_HISTORY}
            />
          </div>
        </ModalConfirm>
      )}
    </>
  );
};

export default SchedulePostItem;
